import React from "react";
import "./NoteModal.css";

interface NoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  note: string;
  orderCode?: string;
  modelName?: string;
}

const NoteModal: React.FC<NoteModalProps> = ({
  isOpen,
  onClose,
  note,
  orderCode,
  modelName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="note-modal-overlay" onClick={onClose}>
      <div
        className="note-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="note-modal-header">
          <div className="note-modal-header-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
          </div>
          <div className="note-modal-header-text">
            <h3 className="note-modal-title">Sipariş Notu</h3>
            {(orderCode || modelName) && (
              <div className="note-modal-subtitle">
                {orderCode && (
                  <span className="note-modal-order-code">{orderCode}</span>
                )}
                {orderCode && modelName && (
                  <span className="note-modal-separator">•</span>
                )}
                {modelName && (
                  <span className="note-modal-model-name">{modelName}</span>
                )}
              </div>
            )}
          </div>
          <button className="note-modal-close" onClick={onClose}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="note-modal-content">
          <div className="note-modal-note-container">
            <div className="note-modal-quote-icon note-modal-quote-open">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
              </svg>
            </div>
            <div className="note-modal-note-text">{note}</div>
            <div className="note-modal-quote-icon note-modal-quote-close">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M18 7h-3l-2 4v6h6v-6h-3zM10 7H7l-2 4v6h6v-6H8z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="note-modal-footer">
          <button className="note-modal-btn" onClick={onClose}>
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoteModal;
